import React from 'react';
import urlJoin from 'proper-url-join';
import { env } from 'constants/env';
import { useApplyProvider } from 'V2/Apply';
import { useIsMobile } from '../Helpers';

import colorLogo from 'V2/Shared/Assets/logo-color.svg';
import whiteLogo from 'V2/Shared/Assets/logo-white.svg';
import { WhiteLabelStatusData } from 'V2/Types';

const LogoMarkSVG = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 253 259"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Clearcover"
  >
    <path
      d="M184.59 169.42c-12.43 17.09-32.58 28.2-55.33 28.2-37.77 0-68.39-30.62-68.39-68.39 0-37.77 30.62-68.39 68.39-68.39 22.75 0 42.89 11.11 55.32 28.2h66.98C234.67 37.63 186.32.5 129.26.5 58.16.5.53 58.14.53 129.23c0 71.1 57.64 128.73 128.73 128.73 57.06 0 105.42-37.14 122.3-88.55l-66.97.01zM238.53.5c7.22 0 13.05 5.91 13.05 13.13 0 7.22-5.83 13.16-13.05 13.16-7.19 0-12.95-5.94-12.95-13.16S231.35.5 238.53.5zm0 23.69c5.69 0 10.17-4.59 10.17-10.57S244.22 3.1 238.53 3.1c-5.69 0-10.17 4.55-10.17 10.53 0 5.98 4.48 10.56 10.17 10.56zm-1.64-3.52h-2.7V6.37h4.94c2.77 0 4.84 1.95 4.84 4.48 0 1.99-1.28 3.63-3.13 4.23l3.2 5.58h-3.1l-2.99-5.33h-1.07v5.34h.01zm1.86-7.68c1.6 0 2.49-.78 2.49-2.1 0-1.38-.89-2.17-2.49-2.17h-1.85v4.27h1.85z"
      fill="#4024D3"
    />
  </svg>
);

const LogoSVG = ({ width, height }: { width: number; height: number }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 1117 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Clearcover"
  >
    <path
      d="M174.73 161.41c-24.52 0-44.46-19.95-44.46-44.46V.75h30.38v116.2c0 7.77 6.32 14.09 14.09 14.09v30.37h-.01zm66.91-.06c27.43 0 50.14-15.14 57.47-38.08h-34.06c-4.26 7.57-13.24 10.88-23.65 10.88-15.85 0-27.44-11.35-29.56-24.83h88.22c.47-2.84.71-6.15.71-9.22 0-31.69-24.83-59.84-60.07-59.84-34.29 0-60.31 26.73-60.31 60.55 0 33.82 26.24 60.54 61.25 60.54zm-28.62-74.5c3.07-12.3 14.43-20.34 27.67-20.34 13.48 0 24.36 8.28 27.43 20.34h-55.1zm157.57 74.5c15.37 0 27.67-6.39 33.11-12.77v11.35h30.51V41.68H403.7v11.11c-5.68-6.15-17.97-12.53-33.11-12.53-33.82 0-59.6 25.07-59.6 60.55 0 35.47 25.78 60.54 59.6 60.54zm2.13-28.38c-17.74 0-31.69-12.54-31.69-32.16 0-19.87 13.95-32.17 31.69-32.17 17.5 0 30.75 12.3 30.75 32.17 0 19.62-13.25 32.16-30.75 32.16zm338.74 28.38c35.24 0 60.78-26.02 60.78-60.55s-25.54-60.55-60.78-60.55-60.78 26.02-60.78 60.55 25.54 60.55 60.78 60.55zm0-29.09c-17.97 0-30.27-13.01-30.27-31.46 0-18.45 12.3-31.69 30.27-31.69 18.21 0 30.27 13.24 30.27 31.69.01 18.45-12.06 31.46-30.27 31.46zm101.76 27.67h30.27l43.52-118.25h-31.93l-26.73 76.39-26.49-76.39H769.7l43.52 118.25zm133.45 1.42c27.43 0 50.14-15.14 57.47-38.08h-34.06c-4.26 7.57-13.24 10.88-23.65 10.88-15.85 0-27.44-11.35-29.56-24.83h88.22c.47-2.84.71-6.15.71-9.22 0-31.69-24.83-59.84-60.07-59.84-34.29 0-60.31 26.73-60.31 60.55 0 33.82 26.24 60.54 61.25 60.54zm-28.62-74.5c3.07-12.3 14.43-20.34 27.67-20.34 13.48 0 24.36 8.28 27.43 20.34h-55.1zm-463.63 12.3v60.78h30.27V99.15c.86-15.95 14.06-28.62 30.23-28.62V40.26c-32.88 0-59.62 26.22-60.5 58.89zM86.57 119.7c-5.85 8.04-15.32 13.27-26.02 13.27-17.77 0-32.17-14.4-32.17-32.17 0-17.76 14.4-32.17 32.17-32.17 10.7 0 20.17 5.23 26.02 13.26h31.5c-7.94-24.18-30.69-41.64-57.52-41.64C27.11 40.26 0 67.36 0 100.8s27.11 60.55 60.55 60.55c26.84 0 49.58-17.47 57.52-41.65h-31.5zm520.38 0c-5.85 8.04-15.32 13.27-26.02 13.27-17.77 0-32.17-14.4-32.17-32.17 0-17.76 14.4-32.17 32.17-32.17 10.7 0 20.17 5.23 26.02 13.26h31.5c-7.94-24.18-30.69-41.64-57.52-41.64-33.44 0-60.55 27.11-60.55 60.55s27.11 60.55 60.55 60.55c26.84 0 49.58-17.47 57.52-41.65h-31.5zm412.55-20.55v60.78h30.27V99.15c.86-15.95 14.06-28.62 30.23-28.62V40.26c-32.88 0-59.62 26.22-60.5 58.89zM1103.2 12.78c7.22 0 13.05 5.91 13.05 13.13 0 7.22-5.83 13.16-13.05 13.16-7.19 0-12.95-5.94-12.95-13.16s5.76-13.13 12.95-13.13zm0 23.69c5.69 0 10.17-4.59 10.17-10.57s-4.48-10.53-10.17-10.53c-5.69 0-10.17 4.55-10.17 10.53 0 5.98 4.48 10.57 10.17 10.57zm-1.64-3.52h-2.7v-14.3h4.94c2.77 0 4.84 1.95 4.84 4.48 0 1.99-1.28 3.63-3.13 4.23l3.2 5.58h-3.1l-2.99-5.33h-1.07v5.34h.01zm1.85-7.68c1.6 0 2.49-.78 2.49-2.1 0-1.38-.89-2.17-2.49-2.17h-1.85v4.27h1.85z"
      fill="#4024D3"
    />
  </svg>
);

export const Logo = ({
  className,
  useImageTag,
  useMarkOnMobile,
  light,
  height = 16,
  width = 112,
  onErrorScreen = false,
}: {
  className?: string;
  useImageTag?: boolean;
  useMarkOnMobile?: boolean;
  light?: boolean;
  height?: number;
  width?: number;
  onErrorScreen?: boolean;
}) => {
  const isMobile = useIsMobile();
  const useMobileVersion = useMarkOnMobile && isMobile;
  const {
    app: { status },
  } = useApplyProvider();

  const white_label = status.white_label;
  const isChoiceFlow = white_label?.is_choice_flow;
  const whiteLabelData =
    isChoiceFlow || onErrorScreen
      ? (white_label ??
        (JSON.parse(
          sessionStorage.getItem('white_label') ?? '{}'
        ) as WhiteLabelStatusData))
      : null;

  if (whiteLabelData?.logo) {
    const colorVariant = light ? 'white' : 'color';
    const sizeVariant = useMobileVersion ? 'mark' : 'logo';
    const path = whiteLabelData.logo[`${colorVariant}_${sizeVariant}`];

    return (
      <img
        className={`cc-partner-logo ${className}`}
        src={urlJoin(env.apiHost, path)}
        width={useMobileVersion ? 20 : undefined}
        height={useMobileVersion ? 20 : undefined}
        alt="Partner"
      />
    );
  }

  if (useMobileVersion) {
    // Currenly we do not use a white logo mark
    return <LogoMarkSVG />;
  }

  if (light) return <img alt="Clearcover" src={whiteLogo} />;

  return useImageTag ? (
    <img className={className} src={colorLogo} alt="Clearcover" />
  ) : (
    <LogoSVG width={width} height={height} />
  );
};
